<template>
    <div class="agreement">
        <agreement :type="type" />
    </div>
</template>
<script>
import agreement from '../components/agreement.vue'
export default {
    name: 'vipCoachAgreement',
    components: {
        agreement
    },
    data () {
        return {
            type: ''
        }
    },
    created () {
        this.type = this.$route.query.type
    }
}
</script>
<style scoped>
.agreement{
    min-height: 100vh;
    background: #F3F4FB;
}
</style>
